import React, { Component } from 'react';
import './styles.scss';
import BotPannel from '../CommonComponents/BotPannel';
import { botID } from '../constants';
import ConfigHeader from './ConfigHeader';
import GeneralTab from './GeneralTab';
import QueuesTab from './QueuesTab';
import TeamTab from './TeamTab';
import ChannelsTab from './ChannelsTab';
type Props = {
  toasterNotifier: Function;
  selectedBotDetails: any;
  redirectionToLoginPage: Function;
  tenantId: number;
  role: string;
  // MakeAgentAvailability:Function;
  // callAvailabilty:Function;
};

type State = {
  selectedBotid: string;
  selectedBoticonurl: string;
  selectedBotname: string;
  selectedBaseURL: string;
  selectedTab: string;
  toasterNotification: string;
  setFlag: boolean;
  validationPopup: boolean;
  test: string;
  showCollapsepannel: boolean;
  shwBotPannel: boolean;
};

export default class ConfigurationPannel extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = this.setInitialState();
    this.botconfig = this.botconfig.bind(this);
    this.selectedTab = this.selectedTab.bind(this);
    this.toasterNotify = this.toasterNotify.bind(this);
  }
  setInitialState(): State {
    return {
      selectedBotid: '',
      selectedBoticonurl: '',
      selectedBotname: '',
      selectedBaseURL: '',
      selectedTab: 'GENERAL',
      toasterNotification: '',
      setFlag: false,
      validationPopup: false,
      test: '',
      showCollapsepannel: false,
      shwBotPannel: false,
    };
  }
  botconfig(selectedBotdata: any) {
    this.setState({
      selectedBotid: selectedBotdata.botid || selectedBotdata.botId,
      selectedBoticonurl: selectedBotdata.botIconUrl || selectedBotdata.botIconURL,
      selectedBotname: selectedBotdata.botName,
      selectedBaseURL: selectedBotdata.baseURL || selectedBotdata.envURL,
    });
  }
  selectedTab(tab: string) {
    this.setState({
      selectedTab: tab,
    });
  }
  toasterNotify(val: string) {
    this.setState({ toasterNotification: val });
    this.props.toasterNotifier(val);
  }

  getTab() {
    switch (this.state.selectedTab) {
      case 'GENERAL':
        return (
          <GeneralTab
            selectedBotid={this.state.selectedBotid}
            toasterNotify={this.toasterNotify}
            redirectionToLoginPage={this.props.redirectionToLoginPage}
          />
        );
      case 'QUEUES':
        return (
          <QueuesTab
            selectedBotid={this.state.selectedBotid}
            toasterNotify={this.toasterNotify}
            tenantId={this.props.tenantId}
          />
        );
      case 'TEAM':
        return (
          <TeamTab
            selectedBotid={this.state.selectedBotid}
            toasterNotify={this.toasterNotify}
            tenantId={this.props.tenantId}
          />
        );
      case 'TEST & DEPLOY':
        return (
          <ChannelsTab
            selectedBotid={this.state.selectedBotid}
            selectedBaseURL={this.state.selectedBaseURL}
            toasterNotify={this.toasterNotify}
            tenantId={this.props.tenantId}
          />
        );
      default:
        return null;
    }
  }
  hideCollapsepannel() {
    this.setState({
      shwBotPannel: !this.state.shwBotPannel,
    });
  }
  componentDidUpdate(prevProps: Props, prevState: State) {
    if (this.state.selectedBotid !== prevState.selectedBotid) {
      this.setState({
        selectedTab: 'GENERAL',
      });
    }
  }
  componentDidMount() {
    this.setState({
      selectedBotid: this.props.selectedBotDetails[0].botid,
      selectedBoticonurl: this.props.selectedBotDetails[0].botIconUrl,
      selectedBotname: this.props.selectedBotDetails[0].botName,
      selectedBaseURL: this.props.selectedBotDetails[0].baseURL,
    });
    // this.props.MakeAgentAvailability(false,true);
  }
  // componentWillUnmount(){
  //   this.props.callAvailabilty(true)
  // }
  render() {
    if (
      sessionStorage.getItem('roleId') === '1' ||
      sessionStorage.getItem('roleId') === '4' ||
      sessionStorage.getItem('roleId') === '6'
    ) {
      return (
        <div
          className={`${
            this.state.shwBotPannel
              ? 'config-pannel-bot-wrapper'
              : 'config-pannel-wrapper'
          }`}>
          <BotPannel
            fetchbotData={this.botconfig}
            botHeader='Configure'
            botFilterHeader='configure'
            showCollapsepannel={this.state.showCollapsepannel}
            Collapsepannel={this.hideCollapsepannel.bind(this)}
            selectedBotId={this.props.selectedBotDetails[0].botid}
            selectedBotName={this.props.selectedBotDetails[0].botName}
            selectedBotIconUrl={this.props.selectedBotDetails[0].botIconUrl}
            selectedBaseURL={this.props.selectedBotDetails[0].baseURL}
            source='Configuration'
            redirectionToLoginPage={this.props.redirectionToLoginPage}
            tenantId={this.props.tenantId}
            role={this.props.role}
            toasterNotify={this.toasterNotify}
          />
          <div className='config-content-wrapper'>
            <ConfigHeader
              selectedBoticonurl={this.state.selectedBoticonurl}
              selectedBotname={this.state.selectedBotname}
              selectTab={this.selectedTab}
              selectedTab={this.state.selectedTab}
            />
            <div
              className={`config-data-wrapper${
                this.state.selectedTab === 'GENERAL' ? ' general-tab-w' : ''
              }`}
              onMouseOver={() => {
                this.setState({
                  showCollapsepannel: !this.state.showCollapsepannel,
                });
              }}>
              {this.getTab()}
            </div>
          </div>
        </div>
      );
    } else {
      return <div></div>;
    }
  }
}
